// extracted by mini-css-extract-plugin
module.exports = {"s65q50v":"s65q50v"};